import { render, staticRenderFns } from "./MapaClientesMap.vue?vue&type=template&id=e3405c50&scoped=true&lang=pug"
import script from "./MapaClientesMap.vue?vue&type=script&lang=js"
export * from "./MapaClientesMap.vue?vue&type=script&lang=js"
import style0 from "./MapaClientesMap.vue?vue&type=style&index=0&id=e3405c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3405c50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VDivider,VIcon})
